<template>
    <Card :disable="!question.studentSpeechUrl">
        <div class="container">
            <div class="sentence" :class="!question.studentSpeechUrl ? 'grey' : ''">{{question.stem}}</div>
            <div class="control" :class="!question.studentSpeechUrl ? 'grey' : ''">
                <div class="left" :class="question.grade >= 70 ? 'blue' : 'red'">{{question.grade}}</div>
                <div class="right">
                    <div class="playBtn">
                        <VoicePlayer :url="question.studentSpeechUrl"
                            :disabled="!question.studentSpeechUrl"></VoicePlayer>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
    import Card from './Card.vue'
    import VoicePlayer from './VoicePlayer.vue'

    export default {
        props: {
            question: {
                type: Object,
                required: true
            }
        },
        components: {
            Card,
            VoicePlayer
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/styles/variable";
    @import "../assets/styles/mixin";

    .container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .sentence {
            font-family: Helvetica-Bold, sans-serif;
            font-size: $font-size-medium;
            color: $color-text-black;
            font-weight: bold;
            margin-bottom: 10px;
            @include ellipsis(2);
            width: 100%;
            text-align: center;
            &.grey{
                color: $color-text-grey;
            }
        }
        .control {
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            font-size: $font-size-larger;
            &.grey{
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
            }
            .left {
                width: 43px;
                height: 43px;
                margin: 0 10px;
                font-weight: 600;
                line-height: 43px;
                text-align: center;
                border-radius: 100%;
                &.blue {
                    background: $color-btn-blue;
                    color: $color-text-blue;
                }
                &.red {
                    background: $color-btn-red;
                    color: $color-text-red;
                }
            }
            .right {
                .playBtn {
                    width: 43px;
                    height: 43px;
                    margin: 0 10px;
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/VoiceCard.vue